import React, { useEffect, useState } from "react";
import useModal from "../../Hooks/useModal";
import ProfileModalResolver from "./resolver";
import "./modals.scss";
import { FaSpinner } from "react-icons/fa";

function AddProfilesModal(props) {
  const [toggle_select_deselect, setToggle_select_deselect] = useState(false);
  const [profiles_selected, setProfiles_selected] = useState([]);
  const [modalIsLoading, setModalIsLoading] = useState(false);
  const [onlyOnceStatus, setOnlyOnceStatus] = useState([]);
  const { modalExtraData } = useModal();

  const profileModalResolverType =
    modalExtraData?.formVersionId === 2
      ? `${modalExtraData.type}_v2`
      : modalExtraData.type;

  useEffect(() => {
    setModalIsLoading(false);

    // Check master field array if entry already exists
    const { formValues, allowOptionsOnlyOnce, masterFieldArray } =
      modalExtraData;
    if (allowOptionsOnlyOnce?.tableField) {
      const masterFieldArrayData =
        formValues?.[masterFieldArray]?.map(
          (item) => item[allowOptionsOnlyOnce?.tableField]
        ) || [];
      setOnlyOnceStatus([...onlyOnceStatus, ...masterFieldArrayData]);
    }
  }, [modalExtraData]);

  const setModalLoadingState = (booleanValue) => {
    setModalIsLoading(booleanValue);
  };

  const handleClick = (e, profile) => {
    if (e.target.checked) {
      let index_num = profiles_selected.indexOf(profile.id);
      let profiles = [...profiles_selected];
      profiles.splice(index_num, 1);
      setProfiles_selected(profiles);
      setOnlyOnceStatus(
        onlyOnceStatus?.filter(
          (item) =>
            item !==
            profile?.[modalExtraData?.allowOptionsOnlyOnce?.profileField]
        )
      );
    } else {
      setProfiles_selected([...profiles_selected, profile.id]);
      setOnlyOnceStatus([
        ...onlyOnceStatus,
        profile?.[modalExtraData?.allowOptionsOnlyOnce?.profileField],
      ]);
    }
  };

  const toggleSelectDeselect = () => {
    if (toggle_select_deselect) {
      setProfiles_selected([]);
    } else if (!toggle_select_deselect) {
      let newProfiles = profiles.map((profile) => {
        return profile.id;
      });
      setProfiles_selected(newProfiles);
    }

    setToggle_select_deselect(!toggle_select_deselect);
  };

  // function uuidv4() {
  //   return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
  //     var r = (Math.random() * 16) | 0,
  //       v = c == "x" ? r : (r & 0x3) | 0x8;
  //     return v.toString(16);
  //   });
  // }

  // builds form values to add to array of crops that
  // get persisted as the list for addendum A
  const buildFormValues = async (profiles, type) => {
    let addendum_profiles = [];
    profiles.map((profile) => {
      let new_profile = ProfileModalResolver(type).new_profile(profile);
      addendum_profiles.push(new_profile);
    });
    return addendum_profiles;
  };

  // triggered when the user clicks "Finish"
  // adds the built form values to the state of the
  const submitNewProfiles = async () => {
    let profiles_to_build = modalExtraData.profiles.filter((profile) => {
      return profiles_selected.indexOf(profile.id) > -1;
    });
    let addendum_profiles = await buildFormValues(
      profiles_to_build,
      profileModalResolverType
    );
    let isFinished = await modalExtraData.callbacks(addendum_profiles);
    // Close Modal when the data is finished loading onto the table:
    if (isFinished) {
      setModalLoadingState(false);
      props.closeModal();
    }
  };

  const profileRow = (profile, index, type) => {
    const { allowOptionsOnlyOnce } = modalExtraData;

    const checked = profiles_selected.includes(profile.id);
    let disabled = false;

    if (
      allowOptionsOnlyOnce &&
      allowOptionsOnlyOnce?.profileValues?.includes(
        profile?.[allowOptionsOnlyOnce?.profileField]
      )
    ) {
      disabled =
        !checked &&
        onlyOnceStatus?.includes(profile?.[allowOptionsOnlyOnce?.profileField]);
    }

    return (
      <tr key={profile.id}>
        <td>
          <input
            className="usa-checkbox__input"
            id={`profile-${index}`}
            type="checkbox"
            name={`profiles`}
            value={profile.id}
            disabled={disabled}
            checked={checked}
          />
          <label
            className="usa-checkbox__label"
            htmlFor={`profile-${index}`}
            onClick={(e) => {
              if (disabled) return;
              handleClick(e, profile);
            }}
            disabled={disabled}
            checked={checked}
          ></label>
        </td>
        <td>{profile.name}</td>
        {ProfileModalResolver(profileModalResolverType).table.td.map((td) => {
          return <td>{profile[td]}</td>;
        })}
      </tr>
    );
  };

  const { profiles, type } = modalExtraData;

  let profiles_count = profiles.length;
  let selected_count = profiles_selected.length;

  const tableRows = profiles.map((profile, index) => {
    return profileRow(profile, index, type);
  });

  return (
    <div>
      <div
        style={{
          backgroundColor: "rgb(247, 247, 247)",
          border: "1px solid rgb(226, 226, 226)",
          padding: "0rem 2rem",
          width: "120%",
          marginLeft: "-32px",
          marginTop: "-32px",
          marginRight: "-20px",
        }}
        className="modal-header"
      >
        <h3
          style={{
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "1.6",
          }}
        >
          {ProfileModalResolver(profileModalResolverType).title}
        </h3>
      </div>
      <div className="modal-body">
        <p>{ProfileModalResolver(profileModalResolverType).body}</p>

        <p className="selection-label">{`${selected_count} of ${profiles_count} profiles selected`}</p>
        {!modalExtraData?.allowOptionsOnlyOnce && (
          <div className="table-action">
            <span
              onClick={() => toggleSelectDeselect()}
              className="button-link"
            >
              Select / deselect all
            </span>
          </div>
        )}

        <table className="usa-table margin-bottom-5">
          <thead>
            <tr>
              <th scope="col" className="col-checkbox"></th>
              <th scope="col">Profile Name</th>

              {ProfileModalResolver(profileModalResolverType).table.th.map(
                (th) => {
                  return <th scope="col">{th}</th>;
                }
              )}
            </tr>
          </thead>
          <tbody>{profiles_count > 0 ? tableRows : null}</tbody>
        </table>

        <div className="form-actions">
          <div className="form-actions-left" />
          <div className="form-actions-left">
            <button
              type="button"
              className="usa-button btn-extra-wide"
              onClick={() => {
                setModalLoadingState(true);
                submitNewProfiles();
              }}
            >
              {modalIsLoading ? (
                <FaSpinner className="icon-spin" />
              ) : (
                "Populate"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProfilesModal;
